export const REFERRAL = "referral";
export function referral(data) {
	return {
		type: REFERRAL,
		payload: data.payload,
	};
}
